export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://192.168.31.183:3001"
export const DEBUG = process.env.REACT_APP_DEBUG